enum BusinessStructure {
  PARTNERSHIP = "Partnership",
  SOLE_PROPRIETORSHIP = "Sole Proprietorship",
  NON_PROFIT = "Non-Profit",
  LLC = "Limited Liability Company",
  PRIVATE_CORPORATION = "Private Corporation",
  PUBLIC_CORPORATION = "Public Corporation",
}

export default BusinessStructure;
